// Get bearer token from various sources
export function getBearerToken(): string | undefined {
  // First, try to get from meta tags (set by server)
  const authMeta = document.querySelector('meta[name="authorization"]');
  if (authMeta?.getAttribute('content')?.startsWith('Bearer ')) {
    return authMeta.getAttribute('content')?.substring(7);
  }

  // Try custom auth token meta tag
  const customAuthMeta = document.querySelector('meta[name="x-auth-token"]');
  if (customAuthMeta?.getAttribute('content')) {
    return customAuthMeta.getAttribute('content') || undefined;
  }

  // Try URL parameters
  const urlParams = new URLSearchParams(window.location.search);
  const tokenFromUrl = urlParams.get('token');
  if (tokenFromUrl) {
    return tokenFromUrl;
  }

  // Try localStorage
  const tokenFromStorage = localStorage.getItem('token');
  if (tokenFromStorage) {
    return tokenFromStorage;
  }

  return undefined;
}
